/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function EasingPause(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'EasingPause',
      'aria-hidden': true,
      focusable: false,
      width:  18 * scale,
      height: 18 * scale,
      viewBox: '0 0 18 18',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('g', {"stroke":"none","strokeWidth":"1","fill":"currentColor","fillRule":"evenodd"},createElement('path', {"d":"M9 18A9 9 0 1 0 8.999-.001 9 9 0 0 0 9 18m0-.783A8.217 8.217 0 1 1 9 .783a8.217 8.217 0 0 1 0 16.434"}),createElement('path', {"d":"M10.125 6H12v6h-1.875zM6 6h1.922v6H6z"})))
}
